import React from 'react';
import {
	FormControl,
	IconButton,
	InputAdornment,
	TextField
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

const TextInput = ({
	floatingText = '',
	type,
	passwordToggler,
	showPassword,
	adornment,
	value,
	onChange,
	errorText,
	onKeyUp,
	placeholder,
	required,
	min,
	max,
	disabled,
	onClick,
	onBlur,
	multiline,
	id,
	helpPopoverInLabel,
	styles,
	styleInInput,
	disableUnderline,
	stylesAdornment,
	labelNone,
	className,
	stylesTextField,
	autoComplete = 'true',
	styleFloatText,
}) => (
	<FormControl
		style={{
			width: '100%',
			marginTop: '0',
			...styles
		}}
	>
		<TextField
			className={className}
			onSelect={onClick}
			onBlur={onBlur}
			label={
				labelNone ? '' :
					helpPopoverInLabel ? floatingText :
						<div style={{ display: 'flex', ...styleFloatText }}>
							{`${floatingText}${required ? '*' : ''}`}
							{!!errorText &&
								<i
									name={'fas fa-times'}
									style={{
										fontSize: '17px',
										color: 'red',
										marginLeft: '0.2em'
									}}
								/>
							}
						</div>
			}
			value={value}
			multiline={multiline}
			style={{
				marginTop: 0,
				width: '100%',
				...stylesTextField
			}}
			placeholder={placeholder}
			InputLabelProps={{
				shrink: true
			}}
			InputProps={{
				disableUnderline,
				startAdornment: '',
				inputProps: {
					min,
					id,
					max,
					style: {
						fontSize: '15px',
						...styleInInput
					}
				},
				endAdornment: passwordToggler ? (
					<InputAdornment position='end'>
						<IconButton
							aria-label='Toggle password visibility'
							style={{
								outline: 0
							}}
							onClick={event => {
								event.stopPropagation();
								passwordToggler();
							}}
						>
							{showPassword ? <VisibilityOff /> : <Visibility />}
						</IconButton>
					</InputAdornment>
				) : adornment ? (
					<InputAdornment position='end' style={{ ...stylesAdornment }}>
						{adornment}
					</InputAdornment>
				) : (
					''
				)
			}}
			FormHelperTextProps={{
				error: !!errorText,
				className: 'error-text'
			}}
			color='secondary'
			type={type}
			autoComplete={autoComplete}
			disabled={!!disabled}
			onKeyUp={onKeyUp}
			onChange={onChange}
			margin='normal'
			helperText={errorText}
			error={!!errorText}
		/>
	</FormControl>
);

export default TextInput;
